export default "__VITE_ASSET__D8ng6En9__"